
const Prev = ({isActive = false})=>{
return <svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.15991 2.0057L3.57991 6.5957L8.15991 11.1857L6.74991 12.5957L0.749912 6.5957L6.74991 0.595703L8.15991 2.0057Z" fill={isActive? "#FFFFFF":"#A1B6BA"}/>
</svg>
}

export default Prev